export class UomModal {
    id: number;
    nameKey: string;
    name: string;
}